import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { PosthogService } from './posthog.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class PosthogErrorHandler implements ErrorHandler {
    constructor(private injector: Injector) {}

    handleError(error: any): void {
        // Log the error to console first (default behavior)
        console.error('Application error:', error);

        // Get PostHog service instance
        const posthogService = this.injector.get(PosthogService);

        try {
            // Extract relevant error information
            const errorMessage = error?.message || 'Unknown error';
            const errorStack = error?.stack || '';
            const errorName = error?.name || 'Error';

            // Capture the error with PostHog
            if (error instanceof Error) {
                posthogService.captureException(error, {
                    error_name: errorName,
                    error_message: errorMessage,
                    error_stack: errorStack,
                    error_source: 'angular_error_handler',
                    environment: environment.production ? 'production' : 'development',
                    app_name: environment.appName,
                    timestamp: new Date().toISOString(),
                    url: window.location.href,
                    // Add additional context if available
                    user_agent: navigator.userAgent,
                });
            } else {
                // Handle non-Error objects
                posthogService.capture('$exception', {
                    error_message: String(error),
                    error_source: 'angular_error_handler',
                    error_type: 'non_error_exception',
                    environment: environment.production ? 'production' : 'development',
                    app_name: environment.appName,
                    timestamp: new Date().toISOString(),
                    url: window.location.href,
                    user_agent: navigator.userAgent,
                });
            }
        } catch (reportingError) {
            // If error reporting fails, log it but don't throw
            console.error('Failed to report error to PostHog:', reportingError);
        }

        // Re-throw the error in development mode for debugging
        if (!environment.production) {
            throw error;
        }
    }
}